"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var org_hook_1 = require("../../context/OrgContext/org.hook");
var user_hook_1 = require("../../context/UserContext/user.hook");
var general_1 = require("../../lib/general");
var icons_1 = __importDefault(require("../../theme/icons"));
require("./style.scss");
function Table(props) {
    var _a = (0, react_i18next_1.useTranslation)(), i18n = _a.i18n, t = _a.t;
    var organization = (0, org_hook_1.useOrg)().organization;
    var user = (0, user_hook_1.useUser)().user;
    var header = ["category", "icon", "sorting_order", "edit", "delete"];
    return (react_1.default.createElement("div", { style: {
            borderRadius: "10px",
            border: "1px solid #b9b9b9",
        } },
        react_1.default.createElement("table", { id: "rwd-table" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, header.map(function (l) { return (react_1.default.createElement("th", { key: l }, t(l))); }))),
            react_1.default.createElement("tbody", null, props.list.length > 0
                ? props.list.map(function (l, i) {
                    var _a;
                    var icon = (0, general_1.generateMediaLink)(l.category_icon ? l.category_icon : l.icon, organization === null || organization === void 0 ? void 0 : organization.id, (_a = user === null || user === void 0 ? void 0 : user.user_info) === null || _a === void 0 ? void 0 : _a.address_country);
                    return (react_1.default.createElement("tr", { key: l.id },
                        react_1.default.createElement("td", null, (0, general_1.isJsonWithAvailableLang)(l.name, i18n.language, t)),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("a", { onClick: function () {
                                    return window.open(icon, 
                                    // `${l?.category_icon_web ?? l.icon_web}`,
                                    // `${
                                    //   l.category_icon_web
                                    //     ? l.category_icon_web
                                    //     : l.image_web
                                    // }`,
                                    "_blank");
                                } },
                                react_1.default.createElement("img", { className: "category-image", 
                                    // src={l.category_icon}
                                    // src={`${
                                    //   l.category_icon_web?.category_icon_web ??
                                    //   l.image_web
                                    // }`}
                                    src: icon }))),
                        react_1.default.createElement("td", null, l.sorting),
                        react_1.default.createElement("td", { onClick: function () { return props.onEditClick(l, i); } },
                            react_1.default.createElement(icons_1.default, { className: "icon_black", height: 30, name: "edit", width: 30 })),
                        react_1.default.createElement("td", { onClick: function () { return props.onDeleteClick(l, i); } },
                            react_1.default.createElement(icons_1.default, { className: "icon_black", height: 30, name: "delete", width: 30 }))));
                })
                : null))));
}
exports.default = Table;
